<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >   

            <van-divider>运动员/教练/领队食宿安排</van-divider>

            <van-cell-group>
                <van-cell
                        input-align="right"
                        title="食宿人数"
                        label="运动员/教练/领队"
                        :value="sai_member_count"
                />
                <!-- <van-cell
                        input-align="right"
                        title="随行人数"
                        :value="sui_member_count"
                /> -->
                <van-cell
                        input-align="right"
                        title="食宿缴费人数"
                        label="运动员/教练/领队"
                        :value="orderData.countExceptCaipan"
                />
                <!-- <van-field
                        v-model="row.shisu_note"
                        input-align="right"
                        label="备注"
                        rows="2"
                        autosize
                        type="textarea"
                        placeholder="您的食宿特殊要求？"
                /> -->
                <van-cell
                        v-for="(room,rindex) in orderData.list.filter((item)=>{
                            return item.show_caipan==2
                        })"
                        :key="rindex"
                        input-align="right"
                        :label="room.stock>0?'仅剩'+room.last_stock+'间':''"
                        :title="room.name"
                        :value="room.count"
                > 
                <span v-if="room.edit_admin==2">
                <van-stepper v-model="room.count" integer :min="0" :max="room.stock>0?room.last_stock:999999999" @change="countChange" />
                </span>
                <span v-else>
                {{room.count}}人
                <div class="operate-desc-left" >请联系食宿负责人修改</div>
                </span>

                </van-cell>

                <div v-if="row.caipan_count>0 && orderData.list.filter((item)=>{
                                return item.show_caipan==1
                            }).length>0">

                    <van-divider>裁判员食宿安排</van-divider>

                    <van-cell
                            v-for="(room,rindex) in orderData.list.filter((item)=>{
                                return item.show_caipan==1
                            })"
                            :key="rindex"
                            input-align="right" 
                            :title="room.name"
                            :value="room.count"
                    > 
                    <span v-if="room.edit_admin==2">
                    <van-stepper v-model="room.count" integer :min="0" :max="room.stock>0?room.last_stock:1" @change="caipanCountChange(room)" />
                    </span>
                    <span v-else>
                    {{room.count}}人
                    <div class="operate-desc-left" >请联系食宿负责人修改</div>
                    </span>

                    </van-cell>
                </div>
                
                <van-divider>食宿费用信息</van-divider>

                <van-cell
                        input-align="right"
                        title="食宿费用"
                        :value="orderData.price+'元'"
                />


            </van-cell-group>
<van-notice-bar
  wrapable
  v-if="row.saiqu.is_jiesong==1"
  :scrollable="false"
  text="此项费用包含: 车站到酒店的接送站费用、住宿费、餐费及赛场到酒店的接驳费（如涉及）。"
/>    
<van-notice-bar
  wrapable
  v-if="row.saiqu.is_jiesong==2"
  :scrollable="false"
  text="本次比赛不提供接送站服务，此项费用包含: 住宿费、餐费及赛场到酒店的接驳费（如涉及）。"
/>    

            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round  native-type="button" v-rblink="{name:'ISaiApplyFormStep3',query:{id:this.$route.query.id}}">上一步</van-button>
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }
    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import SaiRoomMemberPicker from '@/components/picker/SaiRoomMemberPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
            SaiRoomMemberPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                subjectArray:[],
                subjectOptions:[],
                subjectOptionsAll: [ 
                ],
                row:{
                    caipan_count:0,
                    saiqu:{},
                    room_list:[],
                    member_list:[],
                    room_type:[],
                    shisu_note:'',
                },
                formData: {
                    id: 0,
                    saiqu_name:'xxxxx',
                    danwei:'xxxxx',
                    caipan:[],
                    music:[],
                    famliy:[],
                    tbydy:[],
                    jiaolian:[],
                    member:[],
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
                orderData:{
                    list:[], 
                    price:0,
                    count:0,
                    countExceptCaipan:0,
                },
                sai_member_count:0,
                sui_member_count:0,
            }
        },
        filters: {
            sexName(val){
                return val==1? '男' :'女';
            },
            typeName(val){
                switch (val){
                    case 1:
                        return '领队';
                        break;
                    case 2:
                        return '运动员';
                        break;
                    case 3:
                        return '教练员';
                        break;
                    case 4:
                        return '裁判员';
                        break;
                    default:
                        return '随行人员'
                }
            }
        },
        mounted() {
            document.title = '住宿信息';
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        computed:{
            orderData2(){
                let list = [];
                let price = 0;
                let count = 0;
                let that = this;
                this.row.room_type.map((roomType) =>{
                    let roomTypeRow = {
                        name : roomType.name,
                        price : roomType.price,
                        count : 0
                    }
                    that.row.room_list.map((room) =>{
                        if(room.room_id==roomType.id){
                            roomTypeRow.count ++;
                            count += room.member.length
                        }
                    });
                    list.push(roomTypeRow);
                });
                list.map((rvalue) =>{
                    price += rvalue.price * rvalue.count;
                });
                return {
                    list :list,
                    price :price,
                    count:count
                }
            } ,
            memberOptions(){
                console.log('memberOptions');
                let option = this.row.member_list;
                let selectMember = [];
                this.row.room_list.map((room) =>{
                    if(room.edit==false){
                        selectMember = selectMember.concat(room.member);
                    }
                });
                let foption = option.filter((om) =>{
                    let nosearch = true;
                    selectMember.map((sm) =>{
                        if(sm.num == om.num){
                            //搜索存在num
                            nosearch = false;
                        }
                    });
                    return nosearch;
                })

                return foption;
            },
            memberLimit(){
                if(this.row.room_list.length==0){
                    return 0;
                }
                return this.row.room_list[this.row.room_list.length-1].limit;
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onMemberConfirm(values){
                console.log('onMemberConfirm',values)
                this.showMemberPicker = false;
                this.row.room_list[this.row.room_list.length-1].member = [...values];
            },
            onMemberChange(values){
                console.log('onMemberChange',values)
                this.row.room_list[this.row.room_list.length-1].member = [...values];
            },
            roomAdd(){
                if(this.row.room_list.length >0 && this.row.room_list[this.row.room_list.length-1].edit){
                    return ;
                }
                this.row.room_list.push({
                    name:'',
                    room_id:'',
                    limit:0,
                    price:0,
                    member:[],
                    edit:true
                })
            },
            roomSave(){
                if(this.row.room_list.length ==0 || !this.row.room_list[this.row.room_list.length-1].edit){
                    return ;
                }
                if(!this.row.room_list[this.row.room_list.length-1].name){
                    Toast('请选择房型');
                    return;
                }
                if(this.row.room_list[this.row.room_list.length-1].member.length==0){
                    Toast('请选择人员');
                    return;
                }
                this.row.room_list[this.row.room_list.length-1].edit = false;
            },
            roomRemove(index){
                console.log('roomRemove');
                if(this.row.room_list.length ==0 ){
                    return ;
                }
                this.row.room_list.splice(index,1);
            },
            onRoomTypeConfirm(value, index){
                this.row.room_list[this.row.room_list.length-1].name = value.name;
                this.row.room_list[this.row.room_list.length-1].room_id = value.id;
                this.row.room_list[this.row.room_list.length-1].limit = value.limit;
                this.row.room_list[this.row.room_list.length-1].price = value.price;
                this.row.room_list[this.row.room_list.length-1].member = [];
                this.showRoomTypePicker = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);
                let that = this;
                console.log(that.formData)
                that.formValidate = true; 
                let inmember = 0// 已入住人数
                that.orderData.list.map(item =>{
                    if(item.edit_admin==2 && item.show_caipan==2){
                        inmember+=item.limit*item.count
                    }
                })
                // let yundongyuanCount = that.row.yundongyuan_shisu_count
                // console.log('yundongyuanCount',yundongyuanCount)
                console.log('inmember',inmember)
                if(this.sai_member_count>inmember){
                    // Toast.fail('还有'+(yundongyuanCount-inmember)+'位运动员没有分配好房间');
                    Toast.fail('还有'+(this.sai_member_count-inmember)+'位人员没有分配好房间');
                    return false;
                }
                
                if(that.row.caipan_count>0 && this.orderData.list.filter((item)=>{
                                return item.show_caipan==1
                            }).length>0){
                    let caipanRoomCount = 0;
                    that.orderData.list.map(item =>{
                        if(item.show_caipan==1){
                            caipanRoomCount+=item.limit*item.count
                        }
                    })
                    if(caipanRoomCount==0){
                        Toast.fail('请为裁判分配房间');
                        return false;
                    }
                }
                // return ;
                for (let field in that.formData) {

                }
                that.saveLoading = true;
                that.$api.post('/api/sai/shisuSave', {
                    id: that.row.id,
                    list:JSON.stringify(that.row.room_list),
                    shisu_note:that.row.shisu_note
                }, (res) => {

                    appEvent({
                        name: 'saiApplyDetailReload',
                        query: {
                        }
                    });
                    setTimeout(function () {
                        rbLink({
                            name:'ISaiApplyDetail',
                            query:{
                                id:that.row.id
                            }
                        },'back')
                        that.saveLoading = false;
                    },50);
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            caipanCountChange(item){ 
                if(item.count>0){
                    this.orderData.list.map(item2 =>{
                        if(item2.show_caipan==1 && item2.id != item.id){
                            item2.count = 0
                        }
                    }) 
                }
                this.countChange()
            },
            countChange(){
                let that = this;
                that.row.room_list = [];
                that.orderData.count = 0;
                that.orderData.price = 0;
                that.orderData.countExceptCaipan = 0;
                that.orderData.list.map(item =>{
                    console.log('item',item)
                    that.orderData.count += item.limit*item.count;
                    if(item.show_caipan==2){
                        that.orderData.countExceptCaipan += item.limit*item.count;
                    }


                    that.orderData.price += item.price*item.count * that.row.days;
                    for(let i=0; i< item.count ; i++){
                        that.row.room_list.push({
                            name:item.name,
                            room_id:item.id,
                            limit:item.limit,
                            price:item.price,
                            member:[],
                            saiji:that.row.saiji,
                            saiqu:that.row.saiqu,
                            user_id:that.row.user_id,
                            baoming_id:that.row.id,
                        })
                    }
                });
                console.log('that.row.room_list',that.row.room_list)
            },
            fetch(){
                let that = this;
                that.$api.post('/api/sai/step4detail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;
                    that.orderData.price = 0;
                    that.orderData.count = 0;
                    that.orderData.list = that.row.room_type;
                    // that.orderData.listCaipan = that.row.room_type;
                    that.orderData.list.map(item =>{ 
                        that.$set(item,'count',0); 
                        item.count = 0;
                    });
                    that.row.room_list.map(room=>{
                        that.$set(room,'edit',false); 
                        that.orderData.list.map(item =>{
                            if(item.id == room.room_id){
                                item.count ++;
                            }
                        })
                    }) 

                    that.orderData.list.map(item =>{
                        that.orderData.count += item.limit*item.count;
                        that.orderData.price += item.price*item.count*that.row.days; 
                    });
                    that.sai_member_count = that.row.jiaolian_shisu_count+that.row.yundongyuan_shisu_count+that.row.suixing_shisu_count+that.row.lingdui_shisu_count;
                     
                    that.sui_member_count =  that.row.suixing_shisu_count
 
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep4.vue?ea8af348